//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    props: {
        imgSrc: {
            type: String,
            default: ''
        },
        // 上傳圖片img
        uploadIconImg: {
            type: String,
            default: ''
        },
        onRemove: Function,
        onPreview: Function
    },
    watch: {
        imgSrc(val, oldVal) {
            if (val) {
                this.loading = false
            }
        },
    },
    data() {
        return {
            showMask: false,
            dialogVisible: false,
            loading: false
        }
    },
    methods: {
        handlePictureCardPreview() {
            if (!this.dialogVisible) {
                this.dialogVisible = true
            }
        },
        handleRemove() {
            if (this.onRemove && typeof this.onRemove == "function") {
                this.onRemove(this.imgSrc)
                this.showMask = false
            }
        },
        onMouseEnter() {
            if (!this.imgSrc) {
                return
            }
            this.showMask = true
        },
        onMouseLeave() {
            if (!this.imgSrc) {
                return
            }
            this.showMask = false
        }
    },
    computed: {
        handleImage() {
            return  require("@/assets/images/" + this.uploadIconImg)
        }
    }
}
